module.exports = __webpack_public_path__ + "img/PT6250.1e63e507.png";